import React, { useMemo } from 'react';
import { Divider, Text, useColorMode, VStack } from '@chakra-ui/react';

import { useCalendarSettings, useFilters } from '../../../../lib/context';
import { SelectFilterComponent } from './SelectFilterComponent';
import { __ } from '../../../../lib/i18n';

export const LocationFilters = () => {
	const { filters, defaultFilters } = useFilters();
	const { colorMode } = useColorMode();
	const { settings } = useCalendarSettings();

	const { filtersTextColor, calendarBordersColor } = settings.styles[colorMode];

	const isCitiesFilterDisabled = !filters.selectedStates.length || !filters.selectedCountries.length;
	const isStatesFilterDisabled = !filters.selectedCountries.length;

	const stateOptions = useMemo(
		() => (isStatesFilterDisabled ? [] : defaultFilters.states),
		[isStatesFilterDisabled, defaultFilters.states]
	);

	const cityOptions = useMemo(
		() => (isCitiesFilterDisabled ? [] : defaultFilters.cities),
		[isCitiesFilterDisabled, defaultFilters.cities]
	);

	return (
		<VStack w='full' alignItems='flex-start'>
			<Text fontSize='sm' fontWeight='700' mt={2} mb='0px !important' color={filtersTextColor}>
				{__('Location')}
			</Text>
			<SelectFilterComponent
				placeholder={__('Select Country')}
				options={defaultFilters.countries}
				selectedOptions={filters.selectedCountries}
				filterKey='selectedCountries'
				color={filtersTextColor}
			/>
			<SelectFilterComponent
				placeholder={__('Select State')}
				options={stateOptions}
				selectedOptions={filters.selectedStates}
				filterKey='selectedStates'
				color={filtersTextColor}
				disabled={isStatesFilterDisabled}
			/>
			<SelectFilterComponent
				placeholder={__('Select City')}
				options={cityOptions}
				selectedOptions={filters.selectedCities}
				filterKey='selectedCities'
				color={filtersTextColor}
				disabled={isCitiesFilterDisabled}
			/>
			<Divider borderColor={calendarBordersColor} />
		</VStack>
	);
};
